<template>

  <div>
    <table width="100%">
      <tr>
        <td width="20%">
          <img src="../../../../wwwroot/Images/logo.png" style="width: 100px; height: 100px;">
        </td>
        <td width="60%" style="text-align: center">
          <h3 style="margin-bottom: 0px;">
            <!--{{institue.Name}}-->
            University Of Kotli Azad Jammu & Kashmir
          </h3>
          <h3>Download Admit Card For Entry Test 2021</h3>
        </td>
        <td width="20%" style="text-align: right;">
          <div style="text-align: center; float:right">

          </div>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <hr />
        </td>
      </tr>
    </table>
    <div class="card-header with-border">
      <div class="card-title">
        <h3>Download Admit Card</h3>
      </div>
    </div>
    <div>
      <div>
        <div class="col-md-4">
          <b>Enter Form No. </b>
          <div class="input-group input-group-sm">
            <input type="text" class="form-control" v-mask="'###########'" v-model="rollNum">
            <span class="input-group-append">
              <button class="btn btn-info btn-flat" type="button" v-on:click="search()">Download pdf</button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        rollNum: "",
      }
    },
  

    methods:
    {
      search: function () {
        var vm = this;
        axios.post('/api/AdmissionApi/AdmitCardPrint?rollNum=' + vm.rollNum)
          .then(function (response) {
            if (response.data.status) {

            }
            else {
              toastr.error(response.data.masg);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
    }
  })
</script>




// WEBPACK FOOTER //
// src/components/onlineadmission/admitCardPrint.vue